<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="2" width="28" height="28" stroke="currentColor" stroke-width="2"/>
<path d="M11.5 2V30" stroke="currentColor"/>
<path d="M20.5 2V30" stroke="currentColor"/>
<path d="M2 5.5H30" stroke="currentColor"/>
<path d="M2 11.5H30" stroke="currentColor"/>
<path d="M2 17.5H30" stroke="currentColor"/>
<path d="M2 23.5H30" stroke="currentColor"/>
<rect x="1.5" y="2" width="29" height="3.5" fill="currentColor"/>
</svg>
